
import Vue from 'vue';
import Router from 'vue-router';
import storage from './localStorage';
import sv from './staticVariables';
import store from './store';

Vue.use(Router);

// 默认权限下的路由
let constRouter = [
  {
    path: '/layout',
    name: 'layout',
    component: () => import("@/components/layout.vue")
  },
  {
    path: '/',
    name: 'home',
    component: () => import("@/views/home/home.vue")
  },
  {
    path: '/home',
    name: 'home',
    component: () => import("@/views/home/home.vue")
  },
  {
    path: '/home-userInfo',
    name: 'home-userInfo',
    component: () => import("@/views/home/home-userInfo.vue")
  },
   //数据服务协议
  {
    path: "/protocol",
    name: "protocol",
    component: () => import("@/views/home/protocol.vue"),
  },
   //我的
  {
    path: "/mine",
    name: "mine",
    component: () => import("@/views/mine/index.vue"),
  },
  //查看报告
  {
    path: "/report",
    name: "report",
    component: () => import("@/views/home/report.vue"),
  },
  //扫描完成
  {
    path: "/reportFinish",
    name: "reportFinish",
    component: () => import("@/views/home/report-finish.vue"),
  },
  //查看报告详情
  {
    path: "/reportDetail",
    name: "reportDetail",
    component: () => import("@/views/home/report-detail.vue"),
  },
  //产品详情页
  {
    path: "/productDetail",
    name: "productDetail",
    component: () => import("@/views/home/product-detail.vue"),
  },
  //调整微信支付
  {
    path: "/weixinPay",
    name: "weixinPay",
    component: () => import("@/views/home/auth-callback.vue"),
  },
];
//创建路由对象
let router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: constRouter
});

//路由白名单
const whiteList = [
  '/',
  '/layout',
  '/home',
  '/home-userInfo',
  '/protocol',
  '/report',
  '/reportFinish',
  '/mine',
  '/reportDetail',
  '/productDetail',
  '/weixinPay'
];

let asyncRouter;
// 导航守卫，渲染动态路由
// router.beforeEach((to, from, next) => {
//   if (whiteList.indexOf(to.path) !== -1) {
//     //如果当前路由在白名单中,直接执行下一步
//     setHistoryRouter(to);
//     next();
//   } else {
//     //如果当前路由不在白名单中,则获取缓存中路由添加到路由组
//     let userRouter = storage.getJsonLocalStorageItem(sv.USER_ROUTER);
//     if (!asyncRouter) {
//       if (userRouter) {
//         asyncRouter = userRouter;
//         setHistoryRouter(to);
//         go(to, next);
//       } else {
//         next('/home');
//       }
//     } else {
//       setHistoryRouter(to);
//       next();
//     }
//   }
// });

//设置历史路由参数
function setHistoryRouter(to) {
  let query = storage.getJsonLocalStorageItem(sv.HISTORY_ROUTER_QUERY) || {};
  if (JSON.stringify(to.query) !== '{}') {
    query[to.path] = to.query;
  }
  storage.setJsonLocalStorageItem(sv.HISTORY_ROUTER_QUERY, query);
  store.commit('changeCurrentPath', to.path);
}

// 添加路由后向下执行
function go(to, next) {
  //处理路由数据(将数据变成符合页面设计结构的格式)
  asyncRouter = handleRouterData(asyncRouter);
  //过滤路由,添加页面引用
  asyncRouter = filterAsyncRouter(asyncRouter);
  // 添加路由
  asyncRouter.forEach(function (r) {
    router.addRoute(r);
  });
  //向下走
  next({ ...to, replace: true });
}

//处理路由数据(将数据变成符合页面设计结构的格式)
function handleRouterData(routerData) {
  let children = [];
  routerData.forEach(function (router) {
    if (Object.prototype.hasOwnProperty.call(router, 'navigationShow')) {
      delete router.navigationShow;
    }
    if (Object.prototype.hasOwnProperty.call(router, 'children')) {
      router.children.forEach(function (childrenRouter) {
        if (Object.prototype.hasOwnProperty.call(childrenRouter, 'navigationShow')) {
          delete router.navigationShow;
        }
        children.push(childrenRouter);
      });
      delete router.children;
    }
    children.push(router);
  });
  return [].concat(children);
}

//路由过滤器(将后台传过来的路由对象转换成vue路由需要的格式)
function filterAsyncRouter(routes) {
  return routes.filter(route => {
    if (route.component) {
      let url = route.component;
      //动态引入对应组件(即之前版本的引入页面)
      route.component = () => import(`@/views/${url}`);
      if (route.children && route.children.length) {
        //如果有子路由添加子路由到集合
        route.children = filterAsyncRouter(route.children);
      }
      return true;
    }
  });
}

export default router;
